// extracted by mini-css-extract-plugin
export default {"button":"typeCodeDrawer_button__zT817"};